module.exports = __webpack_public_path__ + "static/img/h-4.7d806e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/h-4.jpg
// module id = LROg
// module chunks = 1